import { FC, lazy, useEffect } from 'react';
import { Outlet, Route, Routes } from 'react-router-dom';
import { hideAll } from 'tippy.js';
import { useWindowSize } from 'usehooks-ts';
import { Footer } from './components/Footer';
import { Header } from './components/Header';
import { Checkout } from './templates/Checkout';
import { Home } from './templates/Home';
import Pay from './templates/Pay';
import PayReservation from './templates/PayReservation';
import ReservationValidation from './templates/ReservationValidation';
const WavesPage = lazy(() => import('./templates/WavesPage'));

const Layout: FC = () => (
    <>
        <Header />
        <main style={{ minHeight: '100%' }}>
            <Outlet />
        </main>
        <Footer />
    </>
);

export const MainRoutes = () => {
    const windowSize = useWindowSize();
    useEffect(() => {
        hideAll({ duration: 200 });
    }, [windowSize]);

    return (
        <Routes>
            <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/menu-de-ondas" element={<WavesPage />}></Route>
                <Route path="/reserva" element={<ReservationValidation />} />
            </Route>
            <Route path="/pay/:paymentLinkId" element={<Pay />} />
            <Route
                path="/pay/reserva/:paymentLinkId"
                element={<PayReservation />}
            />
        </Routes>
    );
};
